import { useNavigate } from "react-router";
import { Button } from "@repo/ui";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-2xl text-center">
        <div className="relative">
          <h1 className="bg-gradient-primary bg-clip-text text-[180px] leading-none font-black text-transparent select-none sm:text-[220px]">
            404
          </h1>
        </div>

        <div className="mt-8 space-y-4">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">Page Not Found</h2>
          <p className="mx-auto max-w-md text-lg text-gray-600">
            Oops! The page you&apos;re looking for was not found.
            <br />
            It might have been moved or deleted. Please check the URL or return to the homepage.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button size={"pill"} variant="primary" className="w-30" onClick={() => navigate("/")}>
            Go Home
          </Button>
          <Button size={"pill"} variant="outline" className="w-30" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};
